import { useState, useEffect, useRef } from "react";
import { getBrandTheme } from "../../styles/brandTheme";
import { supabase } from "../../lib/supabase";

import WelcomeScreen from "./WelcomeScreen";
import SignUpScreen  from "./SignUpScreen";

// Steps: 0=Welcome, 1=SignUp
// For existingSession (signed-in but onboarding incomplete): auto-completes via useEffect

export default function OnboardingFlow({ onGoToSignIn, existingSession, onComplete }) {
  const appTheme = getBrandTheme();

  const [step, setStep] = useState(0);
  const [animDir, setAnimDir] = useState("forward");
  const hasNavigated = useRef(false);

  // If the user already has a session but onboarding is flagged incomplete,
  // just mark it complete — there are no quiz screens to show them.
  useEffect(() => {
    if (!existingSession) return;
    supabase.from("user_profiles")
      .update({ has_completed_onboarding: true })
      .eq("id", existingSession.user.id)
      .then(({ error }) => { if (error) console.error("[Onboarding] profile update error:", error.message); });
    onComplete();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function advance(nextStep) {
    hasNavigated.current = true;
    setAnimDir("forward");
    setStep(nextStep);
  }

  const slideAnim = hasNavigated.current
    ? `onboardSlide${animDir === "forward" ? "Right" : "Left"} 280ms ease-out`
    : "none";

  function renderStep() {
    switch (step) {
      case 0:
        return (
          <WelcomeScreen
            onGetStarted={() => advance(1)}
            onGoToSignIn={onGoToSignIn}
            appTheme={appTheme}
          />
        );
      case 1:
        return (
          <SignUpScreen
            onGoToSignIn={() => onGoToSignIn(null)}
            onGoToSignInWithData={() => onGoToSignIn(null)}
            appTheme={appTheme}
          />
        );
      default:
        return null;
    }
  }

  return (
    <div style={{ minHeight: "100vh", background: appTheme.pageBackground, overflow: "hidden" }}>
      <style>{`
        @keyframes onboardSlideRight {
          from { transform: translateX(100%); opacity: 0.6; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        @keyframes onboardSlideLeft {
          from { transform: translateX(-100%); opacity: 0.6; }
          to   { transform: translateX(0);     opacity: 1; }
        }
      `}</style>
      <div
        key={step}
        style={{
          minHeight: "100vh",
          animation: slideAnim,
          willChange: "transform",
        }}
      >
        {renderStep()}
      </div>
    </div>
  );
}
